<div class="internal-chat-main-frame">
  <internal-chat-body></internal-chat-body>
  <internal-chat-navbar></internal-chat-navbar>
</div>
